<template>
  <div style="background-color:#fff;height: 100%;">
    <van-sticky :offset-top="0 ">
      <mini_head_top> </mini_head_top>
    </van-sticky>
    <van-row  type="flex"  justify="space-between" style="margin-left :10px; padding: auto; margin-top:10px;text-align: left">
      <van-col :span= '20'>
        <span style="margin-left: 0px; height:16px;width:10px;background:#1dea12; display: inline-block"> </span>
        <span style="font-size:16px; font-weight:700">{{ viewThemeOneDetail.theme }}</span>
      </van-col>
      <van-col >
        <el-link :span= '4' style="margin-right: 10px;" type="warning" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
      </van-col>        
    </van-row >
    <div class = "w-e-text-container"  style="margin-top:10px; height: calc(100vh - 150px); overflow: auto;  background-color: ghostwhite;">
      <van-collapse v-model="activeNames" style="padding:0">
        <van-collapse-item title="" name="1">
        <template #title>
          <el-tag style="padding:0px" size ="mini" type="success">查看答题详情 </el-tag>
          <el-tag type ="danger" size="mini"  v-if="viewThemeOneDetail.usrState == 2 && !viewThemeOneDetail.selfExamOver">
            考试时间还剩:
          </el-tag>
          <span v-if="viewThemeOneDetail.usrState == 2 && !viewThemeOneDetail.selfExamOver">
            {{ timer.minutes }}分{{ timer.seconds }}秒
          </span>
        </template>
        <div style="margin-top: 1px;text-align: left; overflow:auto;">
          <div  class="clearfix">
            <el-tag type ="info" size = "mini" v-if="viewThemeOneDetail.usrState == 1" >
              未作答
            </el-tag>
            <el-tag type ="success" size = "mini" v-else-if="viewThemeOneDetail.usrState == 2" >
              考试中
            </el-tag>
            <el-tag type ="danger" size = "mini" v-else>
              已交卷
            </el-tag>
            <el-tag type ='primary' size="mini" v-if="viewThemeOneDetail.usrState == 2 && !viewThemeOneDetail.selfExamOver" style="cursor: pointer;" @click = savePaper(viewThemeOneDetail.id)>暂存</el-tag>
            <el-tag type ='warning' size="mini" v-if="viewThemeOneDetail.usrState == 2" style="cursor: pointer;" @click = sendPaper(viewThemeOneDetail.id)>交卷</el-tag>
            <el-tag :type ="viewThemeOneDetail.result == 0 ? 'danger': 'success'" size="mini" v-if="viewThemeOneDetail.usrState == 3">
              {{ viewThemeOneDetail.result == 0 ? '不合格': '合格' }}
            </el-tag>
            <el-tag type ="mini" v-if="viewThemeOneDetail.usrState == 3">
              {{ viewThemeOneDetail.score }} 分
            </el-tag>
          </div>
            <div style="margin-top : 2px;font-size: 12px;">
              <span >总分数: {{ viewThemeOneDetail.totalScore }}分; </span>
              <span >及格分数:{{ viewThemeOneDetail.passScore }}分; </span>
              <span >考试时长:{{ viewThemeOneDetail.duration }}分钟; </span>
            </div>
            <div style="margin-top : 2px;font-size: 12px;">注意:少选，多选，错选不得分 </div>
            <div style="margin-top : 2px; font-size: 12px; " v-if="viewThemeOneDetail.usrState == 3">
              <span>
                答题时间: {{ viewThemeOneDetail.beginExamTime }}到{{ viewThemeOneDetail.commitExamTime }}
              </span>
            </div>
            
            <div style="width: 100%;" v-if="viewThemeOneDetail.usrState == 2 && viewThemeOneDetail.selfExamOver">
              <el-tag type ="danger" size="mini" >
               考试结束，请交卷
              </el-tag>
            </div>
        </div>
        <div style=" text-align: left; margin-top:calc(1vh);overflow:auto;">
          <div v-for = "(item,index) in viewThemeOneDetail.qtList" :key="index" style="margin-top:10px">
            <el-tag type ="mini"> {{item.answerCheckType}}</el-tag><span style="padding-left:10px;">{{'共' +item.qbList.length+ '题,' }}</span>
            <span >{{'每题' +item.oneScore+ '分,'}}</span>
            <span>{{'共' + (item.qbList.length * item.oneScore) + '分' }}</span>
            <el-checkbox-group v-model="viewPaperCheckList"  @change="selectedOne">
              <el-checkbox style="margin-left:5px"  v-for = "(ite,index) in item.qbList" :key="ite.id"  
              :label="ite.examQuestionId.toString()" :style = "answerCheckList['$$' +ite.examQuestionId ].length  == 0 ? 'color :rgb(208, 82, 82)': 'color:rgb(12, 239, 12)' "> 
                {{index + 1}}  
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        </van-collapse-item>
      </van-collapse>
      <div style="text-align:left ;  margin-top:10px; overflow:auto; background-color: #fff;">
        <div style=" text-align: left; margin:5px;overflow:auto;">
          <div slot="header" class="clearfix">
            <el-tag size="mini" type="warning">{{ qbView.uniqNo }}</el-tag>
            <el-tag size="mini" >{{ qbView.moduleName }}</el-tag>
            <el-tag size="mini" type="success">{{  qbView.answerCheckType }}</el-tag>
            <el-button  type="danger"  v-if ="viewThemeOneDetail.usrState == 3 && 
             qbView.learnAnswer != null&& qbView.learnAnswer != '' && 
              qbView.learnAnswer != qbView.answer"   style="el-icon--right" 
              @click="recordErrorQb()" size = "small" icon="">加入错题集 
              <i class="el-icon-arrow-right el-icon--right"></i></el-button>
          </div>
          <div style ="margin-top: 10px;">
            <el-tag size="mini" type="warning">问题</el-tag>
            <span style ="margin-left: 10px;">{{qbView.question }}</span>
          </div>
          <div style ="margin-top: 10px;" v-if = "qbView.imageUrlList.length > 0"> 
            <el-tag size="mini" type="warning" style="padding-top: 0px">图片</el-tag>
            <el-badge  v-for="(item,index) in qbView.imageUrlList" :key = "index"  :value="index + 1" class="item">
              <el-image   
                style="width: 100px; height: 100px;margin-left: 10px; "
                :src="item"
                :fit="'fit'">
              </el-image>
            </el-badge>
          </div>
          <div style ="margin-top: 10px;">
            <el-tag  size="mini" type="warning">选项</el-tag>
            <el-checkbox-group v-model="answerCheckList['$$' + qbView.examQuestionId]" >
              <el-checkbox style ="margin-left: 10px;ord-break: break-all;display: block;overflow:
                hidden; text-overflow: ellipsis;white-space: normal" :disabled = " !(viewThemeOneDetail.usrState == 2 && !viewThemeOneDetail.selfExamOver)"  v-for="(item,index ) in qbView.optionValueArr" :label="item.label" :key="index">
                  {{item.name}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div style ="margin-top: 10px;" v-if ="viewThemeOneDetail.usrState == 3" >
            <el-tag size="mini" type="warning">我的答案</el-tag>
            <span v-if ="qbView.learnAnswer != null && qbView.learnAnswer != ''" style ="margin-left: 10px;">{{ qbView.learnAnswer }}</span>
            <span v-else>未作答</span>
            <el-button   style ="margin-left: 50px;" size="mini"  :type="qbView.learnAnswer == qbView.answer ? 'success':'danger'"
              :icon="qbView.learnAnswer == qbView.answer  ? 'el-icon-check': 'el-icon-close'" circle></el-button>
         
             
            </div>
          <div style ="margin-top: 10px;" v-if="viewThemeOneDetail.usrState == 3">
            <el-tag size="mini" type="warning">答案</el-tag>
            <span style ="margin-left: 10px;"> {{qbView.answer }}</span>
          </div >
          <div style ="margin-top: 10px;" v-if="viewThemeOneDetail.usrState == 3">
            <el-tag size="mini" type="warning">解析</el-tag>
            <span style ="margin-left: 10px; font-size: 12px;"> {{qbView.analysis }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top:10px;text-align: center;">
      <el-button type="primary" :disabled = "tiggerNextOrPre" key ="tiggerPre"  @click="getPreQb">
         上一题
      </el-button>
      <el-button type="primary"  :disabled = "tiggerNextOrPre" key ="tiggerNext" style="margin-left:30px" @click="getNextQb">
         下一题
      </el-button>
    </div>
  </div>
</template>                     
<script>
// 引入组
import '@wangeditor/editor/dist/css/style.css'
import { Dialog } from 'vant';
import axios from  '@/api/axiosConfig'
import mini_head_top from "@/mini_pages/mini_head_top"
import {MESSAGE_DURATION} from  '@/api/constant'

import {convertDateFromString} from '@/api/utils'
export default {
  name : 'mini_paper',
  data() {
    return {
      activeNames:["1"],
      timer:{
        noticeSignPaper: false,
        beginExamTime :'',
        timerId :'',
        minutes :'',
        seconds:'',
        duration :''
      },
      viewThemeOneDetail: {
        id : '',
        theme:'',
        // moduleName :'',
        usrState :'',
        score:'',
        beginExamTime :'',
        commitExamTime :'',
        result:'',
        totalScore:'',
        passScore:'',
        examState :'',
        selfExamOver :'',
        duration :'',
        qtList :[]
      },
      tiggerNextOrPre : false,
      allQbList : [],
      viewPaperCheckList:[],
      answerCheckList:{},
      qbView :{
        examQuestionId :'',
        id:'',
        learnAnswer:'',
        analysis:'',
        answer:'',
        question :'',
        optionValueArr:[],
        moduleName:'',
        uniqNo:'',
        answerCheckType :'',
        imageUrlList :[]
      },
      tokenObj:{
        token :''
      }
    }
  },
  methods : {
    timerFunc(){
      if(this.timer.seconds == '' || this.timer.seconds == 0){
        //const startTime = new Date( this.timer.beginExamTime)
        const startTime =  convertDateFromString(this.timer.beginExamTime)
        const endTime = new Date();
        const timeDiff = (startTime.getTime()  + this.timer.duration * 1000 * 60 ) - endTime.getTime()
        if (timeDiff < 0 ){
          this.viewThemeOneDetail.selfExamOver = true
        }else{
          const totalSeconds =  Math.floor(timeDiff / 1000)
          if(!this.timer.noticeSignPaper && totalSeconds < 3 * 60) {
              this.$message({
              showClose: true,
              message: '离考试结束时间不到3分钟，请尽快交卷！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
            this.timer.noticeSignPaper = true
          }
          this.timer.minutes = Math.floor(totalSeconds / 60)
          this.timer.seconds = Math.floor(totalSeconds % 60)
        }
      }else{
        this.timer.seconds = this.timer.seconds  - 1
      }
    },
    recordErrorQb(){

      if(this.viewThemeOneDetail.usrState != 3){
        this.$message({
          showClose: true,
          message: '未交卷，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      if( this.qbView.resultOk){
        this.$message({
          showClose: true,
          message: '您的答案是正确的，不能加入错题集',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      
      
      let url = "/bc/exa/error/addError"
      let dat0 = { qbId:this.qbView.id,errorAnswer:this.qbView.learnAnswer }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '加入错题集成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      })

    }, 
    getNextQb(){
      let qbLen =  this.allQbList.length
      if(qbLen == 0 ){
        this.$message({
          showClose: true,
          message: '无任何考试题目！',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let nowQbId = this.viewPaperCheckList.pop()
      if(nowQbId == null || nowQbId ==''){
       
        let firsItem = this.allQbList[0]
        this.viewPaperCheckList.push(firsItem.examQuestionId.toString())
        this.selectedOne(firsItem.examQuestionId.toString() )
        return 
      }
      let flag= false 
      for(let i = 0 ; i<qbLen; i++) {
          let item = this.allQbList[i]
          if(flag){
            this.viewPaperCheckList.push(item.examQuestionId.toString())
            this.selectedOne(item.examQuestionId.toString() )
            return 
          }
          if(item.examQuestionId.toString() == nowQbId ){
            flag = true
            if( i == qbLen - 1){
              this.viewPaperCheckList.push(nowQbId)
              this.$message({
                showClose: true,
                message: '已经是最后一题',
                type: 'error',
                duration: MESSAGE_DURATION
              })
              return 
            }
          }
      }
    },
    getPreQb(){
      let qbLen =  this.allQbList.length
      if(qbLen == 0 ){
        this.$message({
          showClose: true,
          message: '无任何考试题目！',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        return 
      }
      let nowQbId = this.viewPaperCheckList.pop()
      if(nowQbId == null || nowQbId ==''){

        let firsItem = this.allQbList[0]
        this.viewPaperCheckList.push(firsItem.examQuestionId.toString())
        this.selectedOne(firsItem.examQuestionId.toString() )
        return 
      }
      let flag= false 
      for(let i = qbLen -1 ; i >= 0 ; i -- ) {
          let item = this.allQbList[i]
          if(flag){
            this.viewPaperCheckList.push(item.examQuestionId.toString())
            this.selectedOne(item.examQuestionId.toString() )
  
            return 
          }
          if(item.examQuestionId.toString() == nowQbId ){
            flag = true
            if( i == 0){
              this.viewPaperCheckList.push(nowQbId)
  
              this.$message({
                showClose: true,
                message: '已经是第一题',
                type: 'error',
                duration: MESSAGE_DURATION
              })
              return 
            }
        }
      }
    },
    goHome(){
      this.$router.push({path:'/mini_index'})
    },
    sendPaper(themeId){
      let fieldArr =  Object.keys(this.answerCheckList)
      let answerArr = []
      let count  = 0
      for(let i = 0 ; i< fieldArr.length; i++){
        let examQuestionId =  fieldArr[i].substring(2) ;
        let answerList =  this.answerCheckList[fieldArr[i]]
        if(answerList.length == 0){
          count++ 
        }else{
          let learnAnswer   = answerList.sort().join("")
          answerArr.push({examQuestionId, answer:learnAnswer})
        }
      }
      let message = "请确认是否交卷？"
      if(count != 0){
        message = "检查到还有" + count  + "个题目未作答,请确认是否交卷？"
      }

      
      Dialog.confirm({
        title: '标题',
        message: message,
      })
      .then(() => {
        this.doSendPaper(themeId,answerArr)
      })
      .catch(() => {
        // on cancel
      });
    },
    doSendPaper(themeId,dat){
      let url = "/bc/exa/exam/examSendPaper/" + themeId
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'success',
            duration: MESSAGE_DURATION
          }) 
          this.goHome()
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        }) 
      })
    },
    savePaper(themeId){
      let fieldArr =  Object.keys(this.answerCheckList)
      let answerArr = []
      for(let i = 0 ; i< fieldArr.length; i++){
        let examQuestionId =  fieldArr[i].substring(2) 
        let answerList =  this.answerCheckList[fieldArr[i]]
        if(answerList.length != 0){
          let learnAnswer   = answerList.sort().join("")
          answerArr.push({examQuestionId, answer:learnAnswer})
        }
      }
      if(answerArr.length == 0 ){
        this.$message({
          showClose: true,
          message: '您还未开始答题',
          type: 'error',
          duration: MESSAGE_DURATION
        })
        resavePaperturn 
      }

      Dialog.confirm({
          title: '标题',
          message: '是否要暂存考试答案?',
        })
        .then(() => {
          this.doSavePaper(themeId,answerArr)
        })
        .catch(() => {
          // on cancel
        });
    },
    doSavePaper(themeId,dat){
      let url = "/bc/exa/exam/examSavePaper/" + themeId
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'success',
            duration: MESSAGE_DURATION
          }) 
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    handleViewQb(last){

      this.viewPaperCheckList.push(last)
      let row = '';
      let qtList = this.viewThemeOneDetail.qtList
      for(let i = 0; i< qtList.length ; i++){
        let qbList = qtList[i].qbList
        for(let j = 0; j < qbList.length; j++  ){
          if( qbList[j].examQuestionId == last ){
            row = qbList[j]
            break
          }
        }
      }
      this.qbView.id = row.id
      this.qbView.examQuestionId = row.examQuestionId
      this.qbView.analysis = row.analysis
      this.qbView.answer = row.answer
      this.qbView.question = row.question 
      this.qbView.moduleName=row.moduleName
      this.qbView.learnAnswer=row.learnAnswer
      this.qbView.uniqNo=row.uniqNo
      this.qbView.answerCheckType =row.answerCheckType
      for(let i = 0; i< 5; i++){
        let v =  row['option' + (i + 1)]
        if(v != null &&  v != '') {
          let ch = String.fromCharCode(i + 1 + 64)
          this.qbView.optionValueArr.push(  {  label :ch , name: ch + "."+ v + ";"}  )
        }
      }
      for(let i = 0; i< row.countImage; i++){
        this.qbView.imageUrlList.push({name: row.id , url : row['fileUrl'+ (i+1)]})
      }
    },
    clearTimer (){
      if(this.timer.timerId != ''){
        clearInterval(this.timer.timerId)    
        this.timer.beginExamTime = ''
        this.timer.timerId  = ''
        this.timer.minutes = ''
        this.timer.seconds = ''
        this.timer.duration = ''
      }
    },
    handleViewPaper( id,examCount){
      let dat = {
        id ,student:true, examCount
      }
      let url = "/bc/exa/exam/getExamThemeOneDetail"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          let dat = response.data.data
          // this.viewThemeOneDetail.moduleName = dat.moduleName
          this.viewThemeOneDetail.usrState = dat.usrState
          this.viewThemeOneDetail.score = dat.score
          this.viewThemeOneDetail.beginExamTime = dat.beginExamTime
          this.viewThemeOneDetail.commitExamTime = dat.commitExamTime
          this.viewThemeOneDetail.examState = dat.examState
          this.viewThemeOneDetail.result = dat.result
          this.viewThemeOneDetail.id = dat.id
          this.viewThemeOneDetail.theme = dat.theme
          this.viewThemeOneDetail.totalScore = dat.totalScore
          this.viewThemeOneDetail.passScore = dat.passScore
          this.viewThemeOneDetail.duration = dat.duration
          this.viewThemeOneDetail.selfExamOver  = dat.selfExamOver
          this.viewThemeOneDetail.qtList.splice(0)
          this.viewThemeOneDetail.qtList = [... dat.qtList]
          this.viewPaperCheckList = []
      
          // 正在考试并且未超时
          if(this.viewThemeOneDetail.usrState == 2 &&  !this.viewThemeOneDetail.selfExamOver) {
            this.timer.beginExamTime = response.data.data.beginExamTime
            this.timer.duration = dat.duration
            this.timer.timerId = setInterval(this.timerFunc,1000)
          }
      
          let first = this.viewThemeOneDetail.qtList[0].qbList[0].examQuestionId
          for(let  i = 0 ;i< this.viewThemeOneDetail.qtList.length ; i++){
            let qt =this.viewThemeOneDetail.qtList[i]
            for(let  j = 0 ;j< qt.qbList.length ; j++){
              let qb = qt.qbList[j]
              let arr = []
              // 保证动态绑定
              if(dat.usrState >= 2 && qb.learnAnswer != null && qb.learnAnswer != ''){
                arr = [... qb.learnAnswer]
              }
              this.allQbList.push(qb)
              this.$set(this.answerCheckList,'$$' + qb.examQuestionId,arr)
            }
          }
         
          setTimeout(()=> this.handleViewQb(first.toString()),300)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    selectedOne( val){
      this.clearViewQbForm()
      let last= this.viewPaperCheckList.pop()
      this.viewPaperCheckList = []
      setTimeout(()=> this.handleViewQb(last),200)
    },
    clearViewQbForm(){
      this.qbView.id = ''
      this.qbView.answerCheckType = ''
      this.qbView.examQuestionId = ''
      this.qbView.analysis = ''
      this.qbView.answer = ''
      this.qbView.question = ''
      this.qbView.moduleName = ''
      this.qbView.learnAnswer = ''
      this.qbView.uniqNo= ''
      this.qbView.optionValueArr.splice(0)
      this.qbView.imageUrlList.splice(0)
    },
  },
  beforeRouteLeave(to, from, next){
    this.clearTimer()
    next();
  },
  beforeDestroy(){
    this.clearTimer()
  },
  created () {
    this.viewThemeOneDetail.id = this.$route.query.id
    let examCount = this.$route.query.examCount
    setTimeout(()=>{this.handleViewPaper(this.viewThemeOneDetail.id,examCount)},200)
  },
  mounted() {
     
  },
  components:{
      mini_head_top
    }
}
</script>

<style lang="less" scoped>
.el-card {
  height: 99%

}
/deep/.el-card__body {
  padding-top:0px;
}
.text {
  font-size: 14px;
  color: #000;
}

.notice-content-view {
  border: 3px solid #ccc;
  border-radius: 5px;
  padding: 0 10px;
  margin-top: 20px;
  overflow-x: auto;
}

.notice-content-view p,
.notice-content-view li {
  white-space: pre-wrap; /* 保留空格 */
}

.notice-content-view blockquote {
  border-left: 8px solid #d0e5f2;
  padding: 10px 10px;
  margin: 10px 0;
  background-color: #f1f1f1;
}

.notice-content-view code {
  font-family: monospace;
  background-color: #eee;
  padding: 3px;
  border-radius: 3px;
}
.notice-content-view pre>code {
  display: block;
  padding: 10px;
}

.notice-content-view table {
  border-collapse: collapse;
}
.notice-content-view td,
.notice-content-view th {
  border: 1px solid #ccc;
  min-width: 50px;
  height: 20px;
}
.notice-content-view th {
  background-color: #f1f1f1;
}

.notice-content-view ul,
.notice-content-view ol {
  padding-left: 20px;
}

.notice-content-view input[type="checkbox"] {
  margin-right: 5px;
}
</style>
    


// WEBPACK FOOTER //
// src/mini_pages/mini_paper.vue